import comp from "./UseTemplateMediaCard";
export default comp;
